import _sfc_main from "./DropdownItem.vue2.js";
/* empty css                  */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const DropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-9f019de6"]]);
export {
  DropdownItem as default
};
//# sourceMappingURL=DropdownItem.vue.js.map
